var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSeeMoreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 33,
    viewBox: "0 0 7 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.99401,
    cy: 2.99401,
    r: 2.99401,
    transform: "matrix(-1 0 0 1 6.71094 0.444336)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.98944,
    cy: 2.98944,
    r: 2.98944,
    transform: "matrix(-1 0 0 1 6.71094 13.4409)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.98924,
    cy: 2.98924,
    r: 2.98924,
    transform: "matrix(-1 0 0 1 6.71094 26.4282)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeeMoreWhite);
export default __webpack_public_path__ + "static/media/IconSeeMoreWhite.bdaf790be972f1b1de42a159b0dfb71c.svg";
export { ForwardRef as ReactComponent };